import { render, staticRenderFns } from "./user-examineDetails.vue?vue&type=template&id=6b42cf30&scoped=true&"
import script from "./user-examineDetails.vue?vue&type=script&lang=js&"
export * from "./user-examineDetails.vue?vue&type=script&lang=js&"
import style0 from "./user-examineDetails.vue?vue&type=style&index=0&id=6b42cf30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42cf30",
  null
  
)

export default component.exports